import { RouteApplicationStartupResolveService } from '../core/route-application-startup-resolve.service';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardShellComponent } from './dashboard-shell/dashboard-shell.component';
import { DashboardLookupResolveService } from './shared/services/dashboard-lookup-resolve.service';
import { AuthGuard } from '../core/auth.guard';

const routes: Routes = [
  {
    path: 'dashboard',
    component: DashboardShellComponent,
    canActivate: [AuthGuard],
    resolve: {
      appData: RouteApplicationStartupResolveService,
      lookupData: DashboardLookupResolveService,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule {}
